import { makeStyles } from '@rbx/ui';
import {
  getEngineRevampTableHeaderCellStyle,
  stickyBreadcrumbScrollOffset,
} from '@modules/ui/shared/utils/styles';

const useReferenceMemberDetailContentStyles = makeStyles()((theme) => ({
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '24px',
  },
  iconWrapper: {
    lineHeight: 0,
    flexShrink: 0,
    '& svg': {
      width: '24px',
      height: '24px',
    },
  },
  title: {
    fontWeight: 700,
    lineHeight: '120%',
    scrollMarginTop: stickyBreadcrumbScrollOffset,
  },
  titleDeprecated: {
    fontWeight: 700,
    lineHeight: '120%',
    color: theme.palette.content.disabled,
    scrollMarginTop: stickyBreadcrumbScrollOffset,
  },
  section: {
    marginBottom: '24px',
  },
  toggleIcon: {
    ...getEngineRevampTableHeaderCellStyle(theme),
    marginLeft: 'auto',
    gap: '2px',
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    color: theme.palette.content.muted,
    '& svg': {
      width: '20px',
      height: '20px',
      transform: 'translateY(1px)',
      color: theme.palette.content.muted,
    },
  },
}));

export default useReferenceMemberDetailContentStyles;
